import { Suspense } from 'react';
import { Page, PageBody, PageHeader, PageHeaderTitle, PageLoader } from '@customerio/pluma-components/react';
import { DocumentTitle } from '@/components/page/document-title';
import { useLocation } from '@tanstack/react-router';
import { getWorkspaceIdFromUrl } from '@/utils/workspace-id';
import { EditReportingWebhook } from './form/edit-reporting-webhook';
import { useEditReportingWebhookBreadcrumbs } from './hooks';

type EditPageProps = {
  webhookId: string;
};

/** The edit page. Its URL is a bare webhook id — Ember's shape, kept so old links resolve. */
export default function EditPage({ webhookId }: EditPageProps) {
  // Reactive read: on `/workspaces/last` the id resolves a beat later, and a `window.location`
  // read would never see it land.
  const { pathname } = useLocation();
  const workspaceId = Number(getWorkspaceIdFromUrl(pathname));

  useEditReportingWebhookBreadcrumbs(String(workspaceId), webhookId);

  if (!Number.isInteger(workspaceId) || workspaceId <= 0) {
    return <PageLoader />;
  }

  return (
    <>
      <DocumentTitle title="Edit Reporting Webhook" />
      <Page>
        <PageHeader>
          <PageHeaderTitle>Edit Reporting Webhook</PageHeaderTitle>
        </PageHeader>
        <PageBody>
          <Suspense fallback={<PageLoader />}>
            <EditReportingWebhook webhookId={webhookId} workspaceId={workspaceId} />
          </Suspense>
        </PageBody>
      </Page>
    </>
  );
}
